import { Flame, Truck, Wrench, Store, LifeBuoy, ParkingSquare, Warehouse } from "lucide-react";

const SECTORS = [
  { icon: Flame, label: "Sapeurs-pompiers" },
  { icon: Truck, label: "Services de fourrière" },
  { icon: Wrench, label: "Garages & carrosseries" },
  { icon: Store, label: "Concessions & showrooms" },
  { icon: LifeBuoy, label: "Dépanneurs" },
  { icon: ParkingSquare, label: "Gestionnaires de parking" },
  { icon: Warehouse, label: "Logistique industrielle" },
];

export default function TrustBar() {
  const items = [...SECTORS, ...SECTORS];
  return (
    <section data-testid="trust-bar" className="border-y border-zinc-200 bg-white py-8">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <p className="text-center font-mono-tech text-xs uppercase tracking-[0.2em] text-[#A1A1AA] mb-6">
          Conçu pour les professionnels qui manipulent véhicules et charges lourdes
        </p>
        <div className="relative overflow-hidden">
          <div className="flex w-max animate-marquee gap-12">
            {items.map((o, i) => (
              <div key={i} className="flex items-center gap-2.5 text-[#52525B] shrink-0">
                <o.icon className="h-5 w-5 text-[#0A0A0A]" strokeWidth={2} />
                <span className="font-display text-lg font-bold tracking-tight whitespace-nowrap">{o.label}</span>
              </div>
            ))}
          </div>
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
        </div>
      </div>
    </section>
  );
}
